import { MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';

export const MobileNavigation = ({ scrollToSection, handleWhatsAppClick }) => (
<div id="mobile-navigation" data-testid="mobile-navigation" className="lg:hidden mt-6 pb-4 space-y-4 border-t border-red-900/40 pt-4">
              <button data-testid="mobile-nav-home" onClick={() => scrollToSection('accueil')} className="block w-full text-left text-white hover:text-yellow-400 py-2">
                Accueil
              </button>
              <button data-testid="mobile-nav-services" onClick={() => scrollToSection('services')} className="block w-full text-left text-white hover:text-yellow-400 py-2">
                Services
              </button>
              <button data-testid="mobile-nav-testimonials" onClick={() => scrollToSection('temoignages')} className="block w-full text-left text-white hover:text-yellow-400 py-2">
                Témoignages
              </button>
              <button data-testid="mobile-nav-cities" onClick={() => scrollToSection('villes')} className="block w-full text-left text-white hover:text-yellow-400 py-2">
                Villes
              </button>
              <button data-testid="mobile-nav-contact" onClick={() => scrollToSection('contact')} className="block w-full text-left text-white hover:text-yellow-400 py-2">
                Contact
              </button>
              <Button 
                data-testid="mobile-menu-whatsapp-button"
                onClick={handleWhatsAppClick}
                className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                WhatsApp
              </Button>
            </div>
);
